import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import Theme from "../theme/theme";
import PageHeading from "./library/PageHeading";
import ErrorBoundary from "./shared/error/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

const BasePage = (props: Props) => {
  const { children, title, noPadding, backUrl } = props;

  return (
    <Theme>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <PageWrapper>
          {title && <PageHeading backUrl={backUrl}>{title}</PageHeading>}
          <ErrorBoundary>
            <ContentWrapper noPadding={noPadding}>{children}</ContentWrapper>
          </ErrorBoundary>
        </PageWrapper>
      </QueryClientProvider>
    </Theme>
  );
};

const GlobalStyle = createGlobalStyle`
  body,
  body#employer-jobs-index,
  body#agency-jobs-index,
  body#recruiter-candidates-index {
    overflow: auto;
    color: ${({ theme }) => theme.colors.text};
    background-color: #F9FAFB;
    height: 100%;
  }

  #main-wrapper {
    overflow: auto;
    padding-bottom: 0;
    height: 100%;
  }

  .main-content-wrapper {
    background-color: #F9FAFB;
    min-height: 100%;
  }
`;

const PageWrapper = styled.div`
  position: relative;

  // Margin for handling the fixed side nav.
  padding-left: 60px;
  @media (max-width: 47.9375em) {
    padding-left: 0;
    padding-bottom: 60px;
  }
`;

const ContentWrapper = styled.div<{ noPadding: boolean }>`
  padding: ${({ noPadding }) => !noPadding && "1rem"};

  @media (min-width: 800px) {
    padding: ${({ noPadding }) => !noPadding && "2rem"};
  }

  width: 100%;
  margin: auto;
`;

type Props = {
  children: React.ReactNode;
  title?: string;
  noPadding?: boolean;
  backUrl?: string;
};

export default BasePage;
